import React from "react";
import sec3img from "../../assets/images/sec3img.png";
import PrimaryButton from "../common/PrimaryButton";

const Section3 = () => {
  return (
    <div className="flex overflow-hidden mx-auto max-w-screen-2xl items-center justify-center">
      <div className="py-6 sm:pb-20 mx-4 sm:mx-12 flex flex-col md:flex-row gap-5 sm:gap-10 justify-center items-center">
        <div className="">
          <img src={sec3img} alt="" />
        </div>
        <div className="flex flex-col gap-4">
          <h1 className="jost-regular text-3xl sm:text-5xl max-w-xl">
            Professional Advisory Services to
            <span className="italic font-eiko-thin">
              {" "}
              Strengthen Your Leadership
            </span>
          </h1>
          <p className="max-w-2xl opacity-50">
            Psyche Ethos provides specialised advising solutions to address a
            variety of organisational issues, with an emphasis on governance, in
            addition to problem-solving. We are experts in assessing the
            usefulness of management data given to executives and boards, making
            sure it not only satisfies their requirements but also generates
            useful ideas.
            <br />
            <br />
            Our methodology transcends conventional reporting, revealing
            viewpoints and prospects that have the potential to revolutionise
            strategic management and decision-making. We give CEOs the vision
            and certainty they need to lead their companies ahead.
            <br />
            <br />
            Collaborate with Psyche Ethos to overcome obstacles and achieve
            unmatched productivity and growth.
          </p>
          <PrimaryButton className="w-[300px] uppercase mt-4 sm:mt-6" icon>
            Request Appointment
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default Section3;
